"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.preservation = void 0;
function preservation(text) {
    return " __FIRAST__" + text.toUpperCase() + "__PRESERVATION__ ";
}
exports.preservation = preservation;
